import { Reveal } from "@/components/site/Reveal";

// Section eyebrow + heading block
export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false, className = "" }) => (
  <Reveal className={`${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} ${className}`}>
    {eyebrow && (
      <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-[color:var(--brand-red)]" />
        <span className={`eyebrow ${light ? "text-slate-300" : "text-[color:var(--brand-blue)]"}`}>{eyebrow}</span>
      </div>
    )}
    <h2 className={`mt-4 text-3xl font-bold leading-[1.08] text-balance sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-slate-950"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-lg leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>
    )}
  </Reveal>
);

export default SectionHeading;
